import React from "react";
import VideoModal from "../VideoModal";
import { Link } from "react-router-dom";
import Spacing from "../Spacing";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useTranslation } from "react-i18next";

export default function HeroStyle4({ videoSrc, bgUrl, thumbnailSrc, darkMode }) {
  const { t } = useTranslation();
  
  return (
    <section
      className="cs_hero cs_style_4 position-relative"
      style={{
        backgroundImage: `url(${thumbnailSrc})`,
      }}
    >
      <div className="container">
        <div className="cs_hero_text position-relative">
          <p className="cs_fs_69 cs_extra_bold text-center">
            {t('heroStyle4.mainTitle')}
          </p>
          <p className={`fs-2 text-center cs_hero_four_subtext ${darkMode ? 'cs_color_white_100' : 'cs_color_gray_400'}`}>
            {t('heroStyle4.subtitle')}
          </p>
        </div>
        <div className="cs_hero_content">
          <div className="cs_hero_video">
            <VideoModal videoSrc={videoSrc} bgUrl={bgUrl} />
          </div>
          <div className="cs_hero_btn text-center">
            <Spacing lg="40" md="30" />
            <a
              href="https://calendly.com/nicolas-rs/new-meeting"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="cs_btn cs_style_1">
                {t('heroStyle4.button')}
                <span>
                  <i>
                    <Icon icon="fa6-solid:arrow-right" />
                  </i>
                  <i>
                    <Icon icon="fa6-solid:arrow-right" />
                  </i>
                </span>
              </span>
            </a>
          </div>
        </div>
      </div>
      <div className="cs_hero_shape">
        <svg
          width={458}
          height={475}
          viewBox="0 0 458 475"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.3"
            d="M2.35848 153.351L456.103 1.77286L370.156 472.382L2.35848 153.351Z"
            stroke="#A3A3A3"
            strokeWidth={2}
          />
        </svg>
      </div>
    </section>
  );
}
